module.exports = __webpack_public_path__ + "img/geod_18.4a75f3eb.jpg";